"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PIMDataEntry = /*#__PURE__*/function () {
  function PIMDataEntry() {
    _classCallCheck(this, PIMDataEntry);
  }

  _createClass(PIMDataEntry, [{
    key: "getString",
    value:
    /**
     * @param {object} data
     * @param {string} key
     * @param {string} defaultValue
     * @returns {string}
     * @private
     */
    function getString(data, key, defaultValue) {
      return this.getRaw(data, key) || defaultValue;
    }
    /**
     * @param {object} data
     * @param {string} key
     * @param {boolean} defaultValue
     * @returns {boolean}
     * @private
     */

  }, {
    key: "getBoolean",
    value: function getBoolean(data, key, defaultValue) {
      var value = this.getRaw(data, key);
      return value !== null ? !!value : defaultValue;
    }
  }, {
    key: "getBooleanConfigurationValue",
    value: function getBooleanConfigurationValue(data, key, configurationKey) {
      var _this = this;

      var outputValue = false;
      var productValue = this.getRaw(data, key);

      if (productValue !== null && productValue === true) {
        outputValue = true;
      }

      var configurations = this.getArray(data, configurationKey, []);
      configurations.forEach(function (configuration) {
        var configurationValue = _this.getBoolean(configuration, key, false);

        if (configurationValue === true) {
          outputValue = true;
        }
      });
      return outputValue;
    }
    /**
     * @param {object} data
     * @param {string} key
     * @param {Array} defaultValue
     * @returns {Array}
     * @private
     */

  }, {
    key: "getArray",
    value: function getArray(data, key, defaultValue) {
      return this.getRaw(data, key) || defaultValue;
    }
    /**
     * @param {object} data
     * @param {string} key
     * @returns {*}
     * @private
     */

  }, {
    key: "getRaw",
    value: function getRaw(data, key) {
      return data && (data[key] || data["".concat(key[0].toLowerCase()).concat(key.slice(1))]);
    }
  }]);

  return PIMDataEntry;
}();

var _default = PIMDataEntry;
exports["default"] = _default;